import React, { useState } from 'react';
import countryList from 'i18n-iso-countries';
import Select from 'react-select';
import './CountrySelect.scss';

countryList.registerLocale(require('i18n-iso-countries/langs/fr.json'));

interface Props {
  name?: string;
  onChange?: (...event: any[]) => void;
  onBlur?: () => void;
  placeholder: string;
  defaultValue?: { label: string; value: string };
  value?: { label: string; value: string };
  className: string;
  innerRef?: React.MutableRefObject<any>;
}

const CountrySelect: React.FC<Props> = ({
  name,
  onChange,
  onBlur,
  placeholder,
  defaultValue,
  className,
  value,
  innerRef
}) => {
  const [countries] = useState(
    Object.entries(countryList.getNames('fr')).map(([key, value]) => ({
      value: key,
      label: value
    }))
  );

  return (
    <Select
      name={name}
      defaultValue={defaultValue}
      value={value}
      onChange={(value) => (value && onChange ? onChange(value) : null)}
      onBlur={onBlur}
      options={countries}
      placeholder={placeholder}
      isClearable
      className={className}
      classNamePrefix="sidep-select"
      ref={innerRef}
    />
  );
};

export default CountrySelect;
